import { render } from "./App.vue?vue&type=template&id=1fd89baf"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./components/dtva-header/dtva-header.scss?vue&type=style&index=0&lang=scss"
import "./components/dtva-footer/dtva-footer.scss?vue&type=style&index=1&lang=scss"
import "@groot/falbala/src/core/scss/drei.scss?vue&type=style&index=2&lang=scss"

import exportComponent from "/appl/bamboo/bamboo-agent-home-5/xml-data/build-dir/PORTAL-DREITVWEBUI-JOB1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__